export default "__VITE_ASSET__FS2NTFSf__"